var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h3',{attrs:{"id":"hSocialMedia"}},[_vm._v(_vm._s(_vm.$t("headers.social-media")))]),_c('IconLinks',{attrs:{"iconLinks":_vm.socialMediaSites}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }